import React, { useContext } from 'react';
import { StyledAlert } from './index.styles';
import { renderedData } from '../../organisms/SearchResults/searchResultsMainComponent';
import { SearchResultAlertContext } from '../../organisms/SearchResults/index.context';
import clsx from 'clsx';
import { errorMessageRedirection } from '../../organisms/SearchResults/index.constant';
import { addSubDirectoryPrefix } from '../../utils/src/helper';
import { usePageContext } from '../../context/PageContext/index';

declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface HTMLAttributes<T> {
    custom_click_track_value?: string;
  }
}

export const AlertNotification: React.FC<{
  isNonPropertyList?: boolean;
  setLinkClick?: () => void;
  clickTrackingText?: string;
  isAloneOnPage?: boolean;
}> = ({ isNonPropertyList = false, setLinkClick, clickTrackingText, isAloneOnPage }) => {
  const { searchResultAlerts } = useContext(SearchResultAlertContext);
  const { isMapViewEnabled } = useContext(renderedData);
  const { pageVal } = usePageContext();
  const hasLink = searchResultAlerts.linkText && searchResultAlerts.errorMessage?.includes('${AlertLinkTextLabel}');
  const errorMessages = searchResultAlerts.errorMessage
    ? searchResultAlerts.errorMessage.split('${AlertLinkTextLabel}')
    : [];

  const errorAlerts =
    searchResultAlerts.type === 'no-hotels' ||
    searchResultAlerts.type === 'no-availability' ||
    searchResultAlerts.type === 'search-form-near' ||
    searchResultAlerts.type === 'property-search' ||
    searchResultAlerts.type === 'result-not-found';

  return (
    <div className={clsx(isMapViewEnabled || pageVal === 'chat' ? '' : 'm-container-fullbleed')}>
      <StyledAlert className={clsx('alert-container', 'container', isAloneOnPage ? 'alone-on-page' : '')}>
        <div className={clsx('warning-container', isNonPropertyList ? 'py-5' : '', isMapViewEnabled ? 'map-view' : '')}>
          <div className={clsx('t-font-s', 'alert', 'm-alert-inline-' + searchResultAlerts.type)}>
            <div className="m-alert-inline-contentWrap" tabIndex={0} role="alert">
              <div className="m-alert-inline-content d-flex">
                <div className={clsx(searchResultAlerts?.icon, 'mr-2 icon-s')}></div>
                <div className="text">
                  {searchResultAlerts.heading ? (
                    <div className="alert-heading t-label-alt-s">{searchResultAlerts.heading}</div>
                  ) : (
                    ''
                  )}
                  {searchResultAlerts.errorMessage ? (
                    <div className="m-alert-inline-sub-content" id="m-alert-inline-sub-content">
                      {errorMessages ? errorMessages[0] : ''}
                      {hasLink ? (
                        <a
                          href={clsx(
                            errorAlerts ? addSubDirectoryPrefix(errorMessageRedirection) : 'javascript:void(0)'
                          )}
                          className="link-error-message t-font-s custom_click_track"
                          onClick={(_e): void => {
                            if (setLinkClick) setLinkClick();
                          }}
                          {...{
                            custom_click_track_value: clickTrackingText ?? '',
                          }}
                        >
                          {searchResultAlerts.linkText}
                        </a>
                      ) : (
                        ''
                      )}
                      {errorMessages[1] ?? ''}
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </StyledAlert>
    </div>
  );
};
